<template>
  <div>
    <v-form-input
      field="code"
      mask="code"
      label="Введите sms-код"
      autocomplete="off"
      v-margin.bottom="2"
    >
      <template slot="error" scope="props">{{
        errorCode || props.error
      }}</template>
    </v-form-input>
  </div>
</template>
<script>
import { declOfNum } from '../../helpers';
import { vButton } from '../../baseComponents/components';

export default {
  name: 'form-phone-verify',
  props: {
    errorCode: String,
    mode: {
      type: String,
    },
    invalidPhone: Boolean,
    invalidCode: Boolean,
    loader: Boolean,
    verified: Boolean,
    disabled: Boolean,
  },
  components: {
    vGreenButton: vButton,
  },
  data() {
    return {
      isShowModal: false,
    };
  },
  methods: {
    handleSendCode(e) {
      this.$emit('send-code');
    },
    handleConfirmCode() {
      this.$emit('confirm-code');
    },
    handleResetPhone() {
      this.$emit('reset');
    },
  },
};
</script>



// WEBPACK FOOTER //
// FormPhoneVerify.vue?195c2c62